import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  Grid,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../AuthProvider";
import { Chip } from '@mui/material';

import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StudentFeeConcessionList = () => {
  const navigate = useNavigate();
  const { oId,board ,pId,role,userId} = useAuth();
  const [formData, setFormData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data
  const [loading, setLoading] = useState(true);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A
  // const [classSectionData, setClassSectionData] = useState([]);
  // const [classOptions, setClassOptions] = useState([]);
  // const [sectionOptions, setSectionOptions] = useState([]);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A");

  const [sscClassSectionData, setSscClassSectionData] = useState([]);
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");


const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
// console.log("selected mode :"+mode);
const [sscClassSectionMap, setSscClassSectionMap] = useState({});
const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag


const [concessionAmount, setConcessionAmount] = useState(null);
const [totalTutionFee, setTotalTutionFee] = useState(null);

useEffect(() => {
    // Replace with your actual API call
    const fetchConcessionAmount = async () => {
      try {
        const response = await fetch(
         
             `${baseUrl}/api/concession/Concession-AllCounts/${oId}/${pId}`
          );
        const data = await response.json();
        setTotalTutionFee(data.totalTutionFee);
        setConcessionAmount(data.totalApprovedConcession); // adjust based on actual API response
      } catch (error) {
        console.error('Error fetching concession amount:', error);
      }
    };

    fetchConcessionAmount();
  }, []);


  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };



    const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  console.log("Selected User:",UserId);


 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 




// //fetch table scrolling data
//   const fetchGetAllTableData = async () => {
//     if (!UserId) return;
//     setLoading(true);
//     setHasFetchedOnce(false);
//     try {
//       const response = await fetch(
//         `${baseUrl}/api/concession/getAllConcessionsByOrgOnly/${oId}/${UserId}/tution_fee`
//       );
//       const data = await response.json();
//       // if (Array.isArray(data)) {
//       //  setOriginalData(data);
//       // setFilteredData(data);
//        if (Array.isArray(data)) {
//       const reversed = [...data].reverse(); // Reverse list first

//       const pending = reversed.filter(item => item.concessionTuitionFeeStatus === "Pending");
//       const approved = reversed.filter(item => item.concessionTuitionFeeStatus === "Approved");
//       const rejected = reversed.filter(item => item.concessionTuitionFeeStatus === "Rejected");

//       const sortedData = [...pending, ...approved, ...rejected]; // Pending on top, approved below

//       setOriginalData(sortedData);
//       setFilteredData(sortedData);

//       } else {
//         setOriginalData([]);
//       setFilteredData([]);
//       }
  
//     } catch (error) {
//       console.error("Error fetching  table data:", error);
//     } finally {
//       setLoading(false);
//       setHasFetchedOnce(true); // mark as fetched
//     }
//   };
  
//   useEffect(() => {
//     fetchGetAllTableData();
//   }, [oId,UserId]);








// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
// const fetchClassRegistrationData = async () => {
//   try {
//     const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
//     const data = await response.json();

//     if (response.ok && Array.isArray(data)) {
//       // Group by class and merge section strings into unique values
//       const classSectionMap = {};

//       data.forEach(item => {
//         const className = item.classRegistration;
//         const sectionList = item.sections.split(",").map(s => s.trim());

//         if (!classSectionMap[className]) {
//           classSectionMap[className] = new Set();
//         }

//         sectionList.forEach(section => classSectionMap[className].add(section));
//       });

//       const classes = Object.keys(classSectionMap);
//       setSscClassOptions(classes); // Class dropdown options
//       setSscClassSectionMap(classSectionMap); // Save for section filtering later

//       // No default selection
//       setSscSelectedClass("");
//       setSscSelectedSection("");
//       setSscSectionOptions([]);
//     }
//   } catch (error) {
//     console.error("Error fetching SSC data:", error);
//   }
// };
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/concession/getAllConcessions/${oId}/${UserId}/tution_fee?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    // if (Array.isArray(data)) {
    //   setOriginalData(data);
    //   setFilteredData(data);
    if (Array.isArray(data)) {
      const reversed = [...data].reverse(); // Reverse list first

      const pending = reversed.filter(item => item.concessionTuitionFeeStatus === "Pending");
      const approved = reversed.filter(item => item.concessionTuitionFeeStatus === "Approved");
      const rejected = reversed.filter(item => item.concessionTuitionFeeStatus === "Rejected");

      const sortedData = [...pending, ...approved, ...rejected]; // Pending on top, approved below

      setOriginalData(sortedData);
      setFilteredData(sortedData);
      
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
    //   if (!selectedCourseType) {
    //     setSelectedCourseType(data[0] || "");
    //   }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/concession/getAllConcessions/${oId}/${UserId}/tution_fee?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
      
    );
    const data = await response.json();
    // if (Array.isArray(data)) {
    //   setOriginalData(data);
    //   setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
      if (Array.isArray(data)) {
      const reversed = [...data].reverse(); // Reverse list first

      const pending = reversed.filter(item => item.concessionTuitionFeeStatus === "Pending");
      const approved = reversed.filter(item => item.concessionTuitionFeeStatus === "Approved");
      const rejected = reversed.filter(item => item.concessionTuitionFeeStatus === "Rejected");

      const sortedData = [...pending, ...approved, ...rejected]; // Pending on top, approved below

      setOriginalData(sortedData);
      setFilteredData(sortedData);
      
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board, selectedCourseType, oId]);  // Removed selectedClass dependency here

// // SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// // INTERMEDIATE: When class or course type changes, update sections
// useEffect(() => {
//   const updateIntermediateSections = async () => {
//     if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
//       await fetchSectionsData();
//     }
//   };
//   updateIntermediateSections();
// }, [interSelectedClass, selectedCourseType, board]);






// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
// useEffect(() => {
//   if (board === "SSC") {
//     if (!sscSelectedClass || !sscSelectedSection) return;
//     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
//   } else if (board === "INTERMEDIATE") {
//     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) return;
//     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
//   }
// }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);

useEffect(() => {
  const fetchData = () => {
    if (board === "SSC") {
      if (sscSelectedClass && sscSelectedSection) {
        fetchClassSectionTableData();
      } else {
        setOriginalData([])
        setFilteredData([]);
        setLoading(false);
      }
    } else if (board === "INTERMEDIATE") {
      if (selectedCourseType && interSelectedClass && interSelectedSection ) {
        fetchCourseClassSectionTableData();
      } else {
        setOriginalData([])
        setFilteredData([]);
        setLoading(false);
      }
    }
  };

  fetchData();
}, [UserId,board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection]);



// Filter data based on search query
  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
      return;
    }

    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.customAdmissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });

    setFilteredData(result);
  }, [searchQuery, originalData]);

  // Convert number to Roman numerals



// const exportToExcel = () => {
//   const isIntermediate = board === "INTERMEDIATE";
//   const dynamicKey = isIntermediate ? "Year" : "Class";

//   const processedData = filteredData.map(
//     ({
//       customAdmissionNumber,
//       course,
//       romanNumberClass,
//       sections,
//       firstName,
//       lastname,
//       fatherFirstName,
//       fatherLastName,
//       mobileNumber,
//       tutionFee,
//       concessionTuitionFeeStatus,
//       concessionTuitionFee,
//     }) => ({
//       AdmissionNumber: customAdmissionNumber,
//       ...(isIntermediate ? { Course: course } : {}),
//       [dynamicKey]: romanNumberClass,
//       Section: sections,
//       StudentName: `${firstName} ${lastname}`,
//       FatherName: `${fatherFirstName} ${fatherLastName}`,
//       MobileNumber: mobileNumber,
//       TuitionFee: tutionFee,
//       ConcessionStatus: concessionTuitionFeeStatus,
//       ConcessionAmount: concessionTuitionFee,
//     })
//   );

//   const workbook = new ExcelJS.Workbook();


//   const worksheet = workbook.addWorksheet(
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_ConcessionFeeList`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_ConcessionFeeList`
//     : "ConcessionFeeList"
// );

//   worksheet.columns = [
//     { header: "Admission No", key: "AdmissionNumber", width: 15 },
//     ...(isIntermediate
//       ? [{ header: "Course", key: "Course", width: 15 }]
//       : []),
//     { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
//     { header: "Section", key: "Section", width: 10 },
//     { header: "Student Name", key: "StudentName", width: 25 },
//     { header: "Father Name", key: "FatherName", width: 20 },
//     { header: "Mobile Number", key: "MobileNumber", width: 15 },
//     { header: "Tuition Fee", key: "TuitionFee", width: 15 },
//     { header: "Concession Status", key: "ConcessionStatus", width: 20 },
//     { header: "Concession Amount", key: "ConcessionAmount", width: 20 },
//   ];

//   processedData.forEach((data) => {
//     worksheet.addRow(data);
//   });

//   worksheet.getRow(1).eachCell((cell) => {
//     cell.font = { bold: true };
//     cell.alignment = { horizontal: "center" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "87CEEB" }, // Light Blue Header
//     };
//   });

//   workbook.xlsx.writeBuffer().then((buffer) => {
//     const blob = new Blob([buffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);

//  link.download = 
//   (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
//     ? `${interSelectedClass}-${interSelectedSection}_ConcessionFeeList.xlsx`
//     : (board === "SSC" && sscSelectedClass && sscSelectedSection)
//     ? `${sscSelectedClass}-${sscSelectedSection}_ConcessionFeeList.xlsx`
//     : "ConcessionFeeList.xlsx";

//     link.click();
//   });

//   handleExportClose();
// };

const exportToExcel = () => {
  const isIntermediate = board === "INTERMEDIATE";
  const dynamicKey = isIntermediate ? "Year" : "Class";

  const processedData = filteredData.map(
    ({
      customAdmissionNumber,
      course,
      romanNumberClass,
      sections,
      firstName,
      lastname,
      fatherFirstName,
      fatherLastName,
      mobileNumber,
       concessionTuitionFeeStatus,
      tutionFee,
     
      concessionTuitionFee,
    }) => ({
      AdmissionNumber: customAdmissionNumber || "NA",
      ...(isIntermediate ? { Course: course || "NA" } : {}),
      [dynamicKey]: romanNumberClass || "NA",
      Section: sections || "NA",
      StudentName: `${firstName || ""} ${lastname || ""}`.trim(),
      FatherName: `${fatherFirstName || ""} ${fatherLastName || ""}`.trim(),
      MobileNumber: mobileNumber || "NA",
       ConcessionStatus: concessionTuitionFeeStatus || "NA",
      TuitionFee: tutionFee || 0,
     
      ConcessionAmount: concessionTuitionFee || 0,
    })
  );

  const workbook = new ExcelJS.Workbook();

  const worksheetName =
    (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
      ? `${interSelectedClass}-${interSelectedSection}_ConcessionFeeList`
      : (board === "SSC" && sscSelectedClass && sscSelectedSection)
      ? `${sscSelectedClass}-${sscSelectedSection}_ConcessionFeeList`
      : "ConcessionFeeList";

  const worksheet = workbook.addWorksheet(worksheetName);

  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    ...(isIntermediate
      ? [{ header: "Course", key: "Course", width: 15 }]
      : []),
    { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Father Name", key: "FatherName", width: 20 },
    { header: "Mobile Number", key: "MobileNumber", width: 15 },
     { header: "Concession Status", key: "ConcessionStatus", width: 20 },
    { header: "Tuition Fee", key: "TuitionFee", width: 15 },
   
    { header: "Concession Amount", key: "ConcessionAmount", width: 20 },
  ];

  // Add data rows with conditional formatting
  processedData.forEach((data) => {
    const row = worksheet.addRow(data);
    const concessionCell = row.getCell("ConcessionAmount");

    if (data.ConcessionAmount > 0) {
      concessionCell.font = { color: { argb: "FF0000" }, bold: true }; // Red & bold
    }
  });

  // Style header
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue
    };
  });

  // Totals
  const totalTuition = processedData.reduce((sum, item) => sum + (item.TuitionFee || 0), 0);
  const totalConcession = processedData.reduce((sum, item) => sum + (item.ConcessionAmount || 0), 0);

 

  const totalRow = worksheet.addRow({
    AdmissionNumber: "Total Amount",
    TuitionFee: `₹${totalTuition.toLocaleString("en-IN")}`,
    ConcessionAmount: `₹${totalConcession.toLocaleString("en-IN")}`,
  });

  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF9C4" }, // Light Yellow
    };
  });

  // Merge A to G for "Total Amount" label (adjust if Course column exists)
  const mergeEndCol = isIntermediate ? "G" : "G";
  worksheet.mergeCells(`A${totalRow.number}:${mergeEndCol}${totalRow.number}`);

  // Download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${worksheetName}.xlsx`;
    link.click();
  });

  handleExportClose();
};


  // Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");

    if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.text(`${interSelectedClass}-${interSelectedSection} ConcessionFeeList`, 10, 8);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.text(`${sscSelectedClass}-${sscSelectedSection} ConcessionFeeList`, 10, 8);
} else {
  doc.text(`ConcessionFeeList`, 10, 8);
}

  // Generated On
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Headers
  const headers = board === "INTERMEDIATE"
    ? [
        "S.No",
        "Course",
        "Year",
        "Section",
        "Student Name",
        "Father Name",
        "Mobile Number",
        "Tuition Fee",
        "Concession Status",
        "Concession Amount"
      ]
    : [
        "S.No",
        "Class",
        "Section",
        "Student Name",
        "Father Name",
        "Mobile Number",
        "Tuition Fee",
        "Concession Status",
        "Concession Amount"
      ];

  // Body
  const bodyData = filteredData.map((row, index) => {
    return board === "INTERMEDIATE"
      ? [
          index + 1,
          row.course || "",
          row.romanNumberClass || "",
          row.sections || "",
          `${row.firstName} ${row.lastname || ""}`,
          `${row.fatherFirstName || ""} ${row.fatherLastName || ""}`,
          row.mobileNumber || "",
          row.tutionFee || "",
          row.concessionTuitionFeeStatus || "",
          row.concessionTuitionFee || "",
        ]
      : [
          index + 1,
          row.romanNumberClass || "",
          row.sections || "",
          `${row.firstName} ${row.lastname || ""}`,
          `${row.fatherFirstName || ""} ${row.fatherLastName || ""}`,
          row.mobileNumber || "",
          row.tutionFee || "",
          row.concessionTuitionFeeStatus || "",
          row.concessionTuitionFee || "",
        ];
  });

  // Table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body: bodyData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Save
   if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
  doc.save(`${interSelectedClass}-${interSelectedSection}_ConcessionFeeList.pdf`);
} else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
  doc.save(`${sscSelectedClass}-${sscSelectedSection}_ConcessionFeeList.pdf`);
} else {
  doc.save(`ConcessionFeeList.pdf`);
}


  handleExportClose();
};

  

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
     if (
  board === "INTERMEDIATE" &&
  interSelectedClass &&
  interSelectedSection
) {
  link.download = `${interSelectedClass}-${interSelectedSection}_ConcessionFeeList.json`;
} else if (
  board === "SSC" &&
  sscSelectedClass &&
  sscSelectedSection
) {
  link.download = `${sscSelectedClass}_${sscSelectedSection}_ConcessionFeeList.json`;
} else {
  link.download = `ConcessionFeeList.json`;
}

    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
<Box display="flex" alignItems="center" justifyContent="space-between" mb={3} flexWrap="wrap">
  {/* Title */}
  <Typography variant="h4" sx={{ fontWeight: "bold", mr: 2 }}>
    Student Fee Concession List
  </Typography>

  {/* Right Side: Tuition + Concession + Add Button */}
  <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
    
    {/* Tuition Fee Box */}
    <Box
      sx={{
        backgroundColor: '#e3f2fd',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 180,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0d47a1' }}>
        Total Tuition Fee:{" "}
        <Box component="span" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          ₹
          {typeof totalTutionFee === 'number'
            ? totalTutionFee.toLocaleString('en-IN')
            : '...'}
        </Box>
      </Typography>
    </Box>

    {/* Concession Amount Box */}
    <Box
      sx={{
        backgroundColor: '#fff3e0',
        padding: '8px 12px',
        borderRadius: '8px',
        minWidth: 180,
        boxShadow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
        Concession Amount:
        <Box component="span" sx={{ color: '#ef6c00', fontWeight: 'bold' }}>
          ₹
          {typeof concessionAmount === 'number'
            ? concessionAmount.toLocaleString('en-IN')
            : '...'}
        </Box>
      </Typography>
    </Box>

    {/* Add Tuition Fee Concession Button */}
    <Button
      variant="contained"
      onClick={() => navigate("/StudentsAddBusList/TutionFeeConcession")}
      sx={{
        backgroundColor: "#3C3972",
        fontWeight: "bold",
        minHeight: "36px",
        fontSize: "0.9rem",
        textTransform: "none",
        color: "white",
        "&:hover": {
          backgroundColor: "#3C3972",
        },
      }}
    >
      Add Tuition Fee Concession
    </Button>
  </Box>
</Box>

       <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  spacing={2}
  style={{ marginTop: "5px",marginBottom: "20px", flexWrap: "nowrap" }}
>
  {/* Left Side: Search + Selects */}
  <Grid item style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <TextField
              label="Search by Name Or Mobile No"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }}
            />

                
                {board === "SSC" && (
                  <>
                    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
                      <InputLabel id="class-select-label">Select Class</InputLabel>
                      <Select
                        labelId="class-select-label"
                        value={sscSelectedClass}
                       
                
                        onChange={(e) => {
                          const selected = e.target.value;
                          setSscSelectedClass(selected);
                          // setMode("classSection");
                      
                          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
                          setSscSectionOptions(sections);
                          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
                        }}
                        
                        label="Select Class"
                        sx={{ height: 35 }}
                      >
                        {sscClassOptions.map((cls) => (
                          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
             
                    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
                  <InputLabel id="section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="section-select-label"
                    value={sscSelectedSection}
                    onChange={(e) => {
                      setSscSelectedSection(e.target.value);
                      // setMode("classSection");
                    }}
                    label="Select Section"
                    sx={{ height: 35 }}
                  >
                    {/* Show placeholder if no sections */}
                    {sscSectionOptions.length === 0 ? (
                      <MenuItem value="" disabled>
                        Select Class
                      </MenuItem>
                    ) : (
                      sscSectionOptions.map((section) => (
                        <MenuItem key={section} value={section}>
                          {section}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                
                  </>
                )}
                
                
                {board === "INTERMEDIATE" && (
                  <>
                    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
                      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                      <Select
                        labelId="intermediate-class-select-label"
                        value={interSelectedClass}
                        onChange={(e) => setInterSelectedClass(e.target.value)}
                        label="Select Year"
                        sx={{ height: 35 }}
                      >
                        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                      </Select>
                    </FormControl>
                
                    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
                      <InputLabel id="course-type-label">Select Course</InputLabel>
                      <Select
                        labelId="course-type-label"
                        value={selectedCourseType}
                        // onChange={(e) => setSelectedCourseType(e.target.value)}
                        onChange={(e) => {
                          setSelectedCourseType(e.target.value);
                          // setMode("classSection");
                        }}
                        
                        label="Select Course"
                        sx={{ height: 35 }}
                      >
                        {courseOptions.map((course, index) => (
                          <MenuItem key={index} value={course}>{course}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                
                
                    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
                  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="intermediate-section-select-label"
                    value={interSelectedSection || ""}
                    onChange={(e) => {
                      setInterSelectedSection(e.target.value);
                      // setMode("classSection");
                    }}
                    label="Select Section"
                    sx={{ height: 35 }}
                  >
                    {interSectionOptions.length === 0 ? (
                      <MenuItem value="" disabled>
                        Select Year and Course
                      </MenuItem>
                    ) : (
                      interSectionOptions.map((section, index) => (
                        <MenuItem key={index} value={section}>
                          {section}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                
                  </>
                )}
                
                {/* <Button
                  onClick={() => {
                    if (board === "SSC") {
                      setSscSelectedClass('');
                      setSscSelectedSection('');
                    } else if (board === "INTERMEDIATE") {
                      setInterSelectedClass('');
                      setSelectedCourseType('');
                      setInterSelectedSection('');
                    }
                
                    setMode("scrolling");
                    // fetchGetAllTableData();
                  }}
                  variant="outlined"
                  color="primary"
                  
                  sx={{marginLeft:'10px'}}
                >
                  Fetch OverAll Data
                </Button> */}

                 {/* {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */} 

   </Grid>
  
    {/* Right Side: Export + Register Button */}
    <Grid
      item
      style={{ display: "flex", gap: "10px", justifyContent: "flex-end", flexWrap: "nowrap" }}
    >
      <Button
        variant="contained"
        onClick={handleExportClick}
        startIcon={<PresentToAllIcon />}
        sx={{
          backgroundColor: "#3C3972",
          fontWeight: "bold",
          minHeight: "28px",
          fontSize: "0.75rem",
          // padding: "2px 12px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#3C3972",
          },
        }}
      >
        Export
      </Button>

      <Menu
        anchorEl={exportAnchorEl}
        open={isExportMenuOpen}
        onClose={handleExportClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          },
        }}
      >
        <MenuItem onClick={exportToExcel} sx={{ "&:hover": { backgroundColor: "#e8f0fe" } }}>
          <ListItemIcon sx={{ color: "#00796b" }}>
            <SimCardDownloadIcon />
          </ListItemIcon>
          <ListItemText
            primary="Excel"
            primaryTypographyProps={{ fontWeight: "bold", color: "#00796b" }}
          />
        </MenuItem>

        <MenuItem onClick={exportToPDF} sx={{ "&:hover": { backgroundColor: "#fdecea" } }}>
          <ListItemIcon sx={{ color: "#d32f2f" }}>
            <PictureAsPdfIcon />
          </ListItemIcon>
          <ListItemText
            primary="PDF"
            primaryTypographyProps={{ fontWeight: "bold", color: "#d32f2f" }}
          />
        </MenuItem>

        <MenuItem onClick={exportToJSON} sx={{ "&:hover": { backgroundColor: "#e8f5e9" } }}>
          <ListItemIcon sx={{ color: "#6a1b9a" }}>
            <FilePresentIcon />
          </ListItemIcon>
          <ListItemText
            primary="JSON"
            primaryTypographyProps={{ fontWeight: "bold", color: "#6a1b9a" }}
          />
        </MenuItem>
      </Menu>
    </Grid>
     
  </Grid>


          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Admission No
                  </TableCell>
                   {(board === "INTERMEDIATE" ) && (
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "4px",
                                        backgroundColor: "#fff9c4",
                                        textAlign: "center",
                                        fontWeight: "Bold",
                                      }}
                                    >
                                      Course
                                    </TableCell>
                                    )}
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                   {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Section
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Father Name
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Mother Name
                  </TableCell> */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Gender
                  </TableCell> */}
                   <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Total Amount
                  </TableCell>

                  <TableCell
                    sx={{
                         borderRight: "2px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Concession Amount
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
               {
              //  !hasFetchedOnce ||
                loading ?(
            //   {loading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell> */}
                    <TableCell
                      colSpan={10}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={10} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.customAdmissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {row.customAdmissionNumber}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        Class-{row.romanNumberClass}
                      </TableCell> */}
                      {board === "INTERMEDIATE" && (
                                            <TableCell
                                              sx={{
                                                borderRight: "1px solid #ddd",
                                                padding: "4px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {row.course}
                                            </TableCell>
                                            )}

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {["NURSERY", "LKG", "UKG"].includes(
                          row.romanNumberClass?.toString().trim()
                        )
                          ? row.romanNumberClass
                          : `${row.romanNumberClass}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >{`${row.firstName} ${row.lastname}`}</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.fatherFirstName || row.fatherLastName
    ? `${row.fatherFirstName || ""} ${row.fatherLastName || ""}`.trim()
    : "NA"}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.mothersFirstName} {row.mothersLastName}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.mobileNumber || "No Number"}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.gender}
                      </TableCell> */}
                      
                       <TableCell
                                            sx={{
                                              borderRight: "1px solid #ddd",
                                              padding: "4px",
                                              textAlign: "center",
                                            }}
                                          >
                                            <Button
                                              variant="contained"
                                              color="success"
                                              style={{
                                                backgroundColor: "#65C63E",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                textTransform: "none",
                                                borderRadius: "20px",
                                              }}
                                            >
                                              ₹{row.tutionFee}{" "}
                                              {/* Paid amount displayed as light green button */}
                                            </Button>
                                          </TableCell>
                     <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
  }}
>
  <Button
    variant="contained"
    style={{
      backgroundColor: "#FFA500", // Orange tone for concession
      color: "#fff",
      fontWeight: "bold",
      textTransform: "none",
      borderRadius: "20px",
    }}
  >
    ₹{row.concessionTuitionFee}
  </Button>
</TableCell>
{/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontWeight:'bold'
                        }}
                      >
                        {row.concessionTuitionFeeStatus}
                      </TableCell> */}
                      <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
  }}
>
  <Chip
    label={row.concessionTuitionFeeStatus}
    sx={{
      fontWeight: 'bold',
      color: '#fff',
      backgroundColor:
        row.concessionTuitionFeeStatus === "Approved"
          ? "#4CAF50" // Green
          : row.concessionTuitionFeeStatus === "Rejected"
          ? "#F44336" // Red
          : "#FFC107", // Yellow for Pending
      borderRadius: "8px",
      px: 2,
      py: 0.5,
      fontSize: "0.9rem",
      textTransform: 'uppercase'
    }}
  />
</TableCell>


                      
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default StudentFeeConcessionList;